import * as React from "react";
import { useContext } from "react";
import { ControlDepartment } from "../../../../ViewModel/ControlDepartment";
import { DropDownListType } from "../../LtlTab/LtlTabTable/RouteCell/DropDownListType";
import { updateRoutePropertyOnProject } from "./UpdateRoutePropertyOnProject";
import { EditProjectContext } from "../../../EditProjectContext";
import { isProjectReadOnly } from "../../../IsProjectReadOnly";
import { DropDownList } from "../../../../../Layout/Inputs/DropDownList";
import { RouteNumberAreaInputProps } from "./RouteNumberAreaInputProps";

export const LaunchClassification = ({ route, disabled = false }: RouteNumberAreaInputProps) => {
  const projectContextProps = useContext(EditProjectContext);
  const { project } = projectContextProps;

  const list: Array<DropDownListType<ControlDepartment>> = [
    {
      text: "1.- Plant/EDC",
      value: ControlDepartment["1.- Plant/EDC"],
    },
    {
      text: "2.- Central FTL",
      value: ControlDepartment["2.- Central FTL"],
    },
    {
      text: "3.- ODC Mgt",
      value: ControlDepartment["3.- ODC Mgt"],
    },
    {
      text: "4.- Plant/EDC",
      value: ControlDepartment["4.- Plant/EDC"],
    },
    { text: "5.- CCT", value: ControlDepartment["5.- CCT"] },
    { text: "8.- Rail", value: ControlDepartment["8.- Rail"] },
    { text: "9.- Other", value: ControlDepartment["9.- Other"] },
  ];

  return (
    <DropDownList
      label="Launch Classification"
      list={list}
      value={route.LaunchClassification}
      onChange={(value) => {
        updateRoutePropertyOnProject(
          "LaunchClassification",
          value,
          route.RouteNumber || "",
          projectContextProps
        );
      }}
      disabled={isProjectReadOnly(project) || disabled}
    />
  );
};
